import type { IconData } from '@stacksjs/iconify-core'

export const windowSection: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 10h6v12H9zm-7 0v11a1 1 0 0 0 1 1h4V10z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M22 8H2v2h5v12h2V10h6v12h2V10h5z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M17 10v12h4a1 1 0 0 0 1-1V10z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M3 2h18a1 1 0 0 1 1 1v5H2V3a1 1 0 0 1 1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default windowSection
